import * as Sentry from "@sentry/react"
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import { AuthProvider, useAuth } from "@/contexts/AuthContext"
import { ProtectedRoute } from "@/components/ProtectedRoute"
import Login from "./pages/Login"
import Mentorings from "./pages/Mentorings/Mentorings"
import { MentoringsFormPage } from "./pages/Mentorings/MentoringsFormPage"
import Companies from "./pages/Companies/Companies"
import CompanyDetail from "./pages/Companies/CompanyDetail"
import NotFound from "./pages/NotFound"
import { DashboardLayout as BaseLayout } from "@/components/Layout/DashboardLayout"
import LoadingOverlay from "./components/LoadingOverlay"
import { ToastProvider } from "./providers/ToastProvider"
import { ModalProvider } from "./components/molecules/Modal/ModalProvider"
import { TooltipProvider } from "./components/atoms/Tooltip/TooltipProvider"
import Dashboard from "./pages/Dashboard/Dashboard"
import ReportsPage from "./pages/Reports/ReportsPage"

const LoginRoute = () => {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return <LoadingOverlay />
  }

  if (isAuthenticated) {
    return (
      <Navigate
        to="/dashboard"
        replace
      />
    )
  }

  return <Login />
}

const App = () => (
  <Sentry.ErrorBoundary fallback={<p>Algo deu errado. Tente recarregar a página.</p>}>
    <AuthProvider>
      <ToastProvider>
        <TooltipProvider>
          <ModalProvider>
            <BrowserRouter>
              <Routes>
                <Route
                  path="/"
                  element={
                    <Navigate
                      to="/login"
                      replace
                    />
                  }
                />
                <Route
                  path="/login"
                  element={<LoginRoute />}
                />
                <Route element={<BaseLayout />}>
                  <Route
                    path="/dashboard"
                    element={
                      <ProtectedRoute>
                        <Dashboard />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/mentorings"
                    element={
                      <ProtectedRoute>
                        <Mentorings />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/mentorings/new/:companyId"
                    element={
                      <ProtectedRoute>
                        <MentoringsFormPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/mentorings/:id/:companyId"
                    element={
                      <ProtectedRoute>
                        <MentoringsFormPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/companies"
                    element={
                      <ProtectedRoute>
                        <Companies />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/companies/:id"
                    element={
                      <ProtectedRoute>
                        <CompanyDetail />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/reports"
                    element={
                      <ProtectedRoute>
                        <ReportsPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/reports/acompanhamento-clientes"
                    element={<Navigate to="/reports" replace />}
                  />
                  <Route
                    path="/reports/auditoria"
                    element={<Navigate to="/reports" replace />}
                  />
                </Route>
                <Route
                  path="*"
                  element={<NotFound />}
                />
              </Routes>
            </BrowserRouter>
          </ModalProvider>
        </TooltipProvider>
      </ToastProvider>
    </AuthProvider>
  </Sentry.ErrorBoundary>
)

export default App
